import SoftwareEngineerImage from "../assets/CertImages/Software Engineer Certificate.png";
import CSharpImage from "../assets/CertImages/CSharp-Basic-Certificate.png";
import JavaScriptImage from "../assets/CertImages/JavaScript (Intermediate).png";
import ProblemSolvingImage from "../assets/CertImages/Problem Solving (Intermediate) Certificate.png";
import PythonImage from "../assets/CertImages/Python (Basic) Certificate.png";
import SQLImage from "../assets/CertImages/SQL (Advanced) Certificate.png";

export interface CertificateItem {
  id: number;
  name: string;
  issuer: string;
  verifyUrl: string;
  image: string;
}

export const CertificatesList: CertificateItem[] = [
  {
    id: 0,
    name: "Software Engineer",
    issuer: "HackerRank",
    verifyUrl: "https://www.hackerrank.com/certificates/iframe/b99c2c0db801",
    image: SoftwareEngineerImage,
  },
  {
    id: 1,
    name: "C#",
    issuer: "HackerRank",
    verifyUrl: "https://www.hackerrank.com/certificates/iframe/952f47afb312",
    image: CSharpImage,
  },
  {
    id: 2,
    name: "JavaScript",
    issuer: "HackerRank",
    verifyUrl: "https://www.hackerrank.com/certificates/iframe/a7bf8881aff8",
    image: JavaScriptImage,
  },
  {
    id: 3,
    name: "Problem Solving",
    issuer: "HackerRank",
    verifyUrl: "https://www.hackerrank.com/certificates/iframe/9c284665d2b5",
    image: ProblemSolvingImage,
  },
  {
    id: 4,
    name: "Python",
    issuer: "HackerRank",
    verifyUrl: "https://www.hackerrank.com/certificates/iframe/18c7ded2147a",
    image: PythonImage,
  },
  {
    id: 5,
    name: "SQL",
    issuer: "HackerRank",
    verifyUrl: "https://www.hackerrank.com/certificates/iframe/b90aa4afaf1f",
    image: SQLImage,
  },
];
